import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface EmptyStateProps {
  /** Main empty state title. Shown in bold. */
  title: string;
  /** Optional short description. Shown in muted color below the title. */
  message?: string;
  /** Optional action (e.g. a button or link). Rendered below the message. */
  action?: ReactNode;
  /** Optional class for the container. */
  className?: string;
}

/**
 * Standard empty state for lists and content areas. Use whenever a list or
 * section has no items to display. Title is bold; message and action are optional.
 */
export function EmptyState({
  title,
  message,
  action,
  className,
}: EmptyStateProps): JSX.Element {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-3 py-12 text-center",
        className
      )}
    >
      <p className="text-mdi font-semibold text-foreground">{title}</p>
      {message != null && message !== "" && (
        <p className="text-sm text-muted-foreground">{message}</p>
      )}
      {action != null && <div className="mt-1">{action}</div>}
    </div>
  );
}
